<i [ngbTooltip]="label"
   [triggers]="'hover click focus'"
   class="bi bi-question-circle-fill"
></i>
